import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["avatar", "label", "variant", "className", "onDelete"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { XMark } from '@box/blueprint-web-assets/icons/Fill';
import { Size4 } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import React__default, { forwardRef } from 'react';
import { Text } from '../text/text.js';
import styles from './input-chip.module.js';
var DELETE_TRIGGER_KEYS = ['Backspace', 'Delete'];
var InputChip = /*#__PURE__*/forwardRef(function (props, ref) {
  var avatarProp = props.avatar,
      label = props.label,
      variant = props.variant,
      className = props.className,
      onDelete = props.onDelete,
      buttonProps = _objectWithoutProperties(props, _excluded); // Clone avatar element to override its props


  var avatar = avatarProp ? /*#__PURE__*/React__default.cloneElement(avatarProp, {
    className: clsx(avatarProp.props.className, styles.avatar),
    size: 'small',
    'aria-hidden': 'true'
  }) : null;

  var handleKeyDown = function handleKeyDown(event) {
    var _buttonProps$onKeyDow;

    if (onDelete && DELETE_TRIGGER_KEYS.includes(event.code)) {
      onDelete();
    }

    (_buttonProps$onKeyDow = buttonProps.onKeyDown) === null || _buttonProps$onKeyDow === void 0 ? void 0 : _buttonProps$onKeyDow.call(buttonProps, event);
  };

  var hasError = variant === 'error';
  return (
    /* eslint-disable-next-line jsx-a11y/role-supports-aria-props */
    jsxs("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
      ref: ref,
      "aria-invalid": hasError,
      className: clsx(styles.container, hasError && styles.error, avatar && styles.avatarContainer, onDelete && styles.deleteButton, className),
      onKeyDown: handleKeyDown,
      type: "button",
      children: [avatar, jsx(Text, {
        as: "span",
        className: styles.label,
        children: label
      }), onDelete &&
      /* Don't use `onClick` handler on icon due to BUIE's "pointer-events: none" style that would cause click event to not trigger  */

      /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
      jsx("span", {
        className: styles.deleteIcon,
        onClick: onDelete,
        children: jsx(XMark, {
          "aria-hidden": true,
          "data-testid": "delete-icon",
          height: Size4,
          width: Size4
        })
      })]
    }))
  );
});
export { InputChip };